import { tienePermiso } from '../../../utils/permisosUtil';

export const permisosGestionUsuarioMixin = {
  computed: {
    permisosGestionUsuario() {
      return {
        accesoModulo: tienePermiso('userManagement'),
        usuarios: {
          accesoPestaña: tienePermiso('usuarios'),
          verUsuarios: tienePermiso('readUser'),
          crearUsuario: tienePermiso('createUser'),
          actualizarUsuario: tienePermiso('updateUser'),
          eliminarUsuario: tienePermiso('deleteUser'),
          activarUsuario: tienePermiso('activeUser'),
          desactivarUsuario: tienePermiso('desactiveUser'),
        },
      };
    },
  },
};
